import axios from "axios";

const API_URL = process.env.VUE_APP_API_BASE_URL;

export const instance = axios.create({
  baseURL: API_URL,
});
export default instance;
